import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from 'src/app/guards/auth.guard';
import { BlurbListComponent } from './components/blurb-list/blurb-list.component';
import { BlurbNewComponent } from './components/blurb-new/blurb-new.component';
import { DistrictViewComponent } from './components/district-view/district-view.component';
import { FranchiseListComponent } from '../manage/components/franchise/franchise-list.component';
import { FranchiseComponent } from './components/franchise/franchise.component';
import { IbisEditorComponent } from './components/ibis-editor/ibis-editor.component';
import { IbisReportComponent } from './components/ibis-report/ibis-report.component';
import { PncReportListComponent } from './components/pnc-report-list/pnc-report-list.component';
import { PncReportComponent } from './components/pnc-report/pnc-report.component';
import { ResearchDetailComponent } from './components/research-detail/research-detail.component';

const researchRoutes: Routes = [
  { // Research detail page
    path: 'detail',
    component: ResearchDetailComponent,
    canActivate: [AuthenticationGuard]
  },
  { // Blurbs editor
    path: 'blurbs',
    component: BlurbListComponent,
    canActivate: [AuthenticationGuard]
  },
  { // blurbs New Item
    path: 'blurbs/new',
    component: BlurbNewComponent,
    canActivate: [AuthenticationGuard],
  },
  { // IBIS editor
    path: 'ibis',
    component: IbisEditorComponent,
    canActivate: [AuthenticationGuard],
  },
  { // IBIS editor
    path: 'ibis/create',
    component: IbisReportComponent,
    canActivate: [AuthenticationGuard],
  },
  { // IBIS editor
    path: 'ibis/create/:data',
    component: IbisReportComponent,
    canActivate: [AuthenticationGuard],
  },
  { // IBIS editor
    path: 'ibis/edit/:id',
    component: IbisReportComponent,
    canActivate: [AuthenticationGuard],
  },
  { // PNC Report list
    path: 'pnc',
    component: PncReportListComponent,
    canActivate: [AuthenticationGuard],
  },
  { // Create PNC Report
    path: 'pnc/create',
    component: PncReportComponent,
    canActivate: [AuthenticationGuard],
  },
  { // PNC Report Detail
    path: 'pnc/detail/:id',
    component: PncReportComponent,
    canActivate: [AuthenticationGuard],
  },
  { // District-View
    path: 'district-view',
    component: DistrictViewComponent,
    canActivate: [AuthenticationGuard],
  },
 /*  { // Frachise Database list
    path: 'franchise',
    component: FranchiseListComponent,
    canActivate: [AuthenticationGuard],
  },
  { // Franchise Create
    path: 'franchise/create',
    component: FranchiseComponent,
    canActivate: [AuthenticationGuard],
  },
  { // Franchise Detail
    path: 'franchise/detail/:id',
    component: FranchiseComponent,
    canActivate: [AuthenticationGuard],
  }, */
  { // Redirect
    path: '',
    redirectTo: 'detail',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(researchRoutes)],
  exports: [RouterModule]
})
export class ResearchRoutingModule { }
